import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Building } from '../../../models/building/building';

@Injectable({
  providedIn: 'root'
})
export class BuildingApiService {
  
  
  // Inject the HttpClient service to make HTTP requests
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/PredioRegiao`;

  

  /**
   * Search for saved Buildings List
   * @returns Observable with the list of buildings/sections
   */
  getSections(department: string, user: string): Observable<Building[]> {

    const params = new HttpParams()
    .set('department', department)
    .set('user', user)

    return this.http.get<Building[]>(`${this.apiUrl}/sections`, { params });
  }

}
